import * as ApiFunctionCalls from '@/utils/ApiFunctionCalls';
const state = {
  tickets: null,
  ticketsTab: null,
  ticketsElementsData: null,
  ticketInfo: {},
  TicketThreads: [],
  saveTicketResult: null
};

const getters = {
  ticketsGetter: state => state.tickets,
  ticketsTabGetter: state => state.ticketsTab,
  ticketInfoGetter: state => state.ticketInfo,
  ticketsElementsDataGetter: state => state.ticketsElementsData,
  TicketThreadsGetter: state => state.TicketThreads,
  saveTicketResultGetter: state => state.saveTicketResult
};

const actions = {
  async getTickets({ commit }, params) {
    try {
      commit('SET_TICKETS', await ApiFunctionCalls.getTickets(params));
    } catch (error) {
      console.log(error);
    }
  },
  async setTicketsThread({ commit }, params) {
    console.log('params', params);
    try {
      commit('SET_TICKETS_THREADS', params);
    } catch (error) {
      console.log(error);
    }
  },
  async getTicketsData({ commit, state }, locationId) {
    try {
      commit(
        'SET_TICKETS_ELEMENTS_DATA',
        await ApiFunctionCalls.getTicketsData(locationId)
      );
    } catch (error) {
      console.log(error);
    }
  },
  async getTicketInfo({ commit, state }, { locationId, ticketId }) {
    try {
      commit(
        'SET_TICKET_INFO',
        await ApiFunctionCalls.getTicketInfo(locationId, ticketId)
      );
    } catch (error) {
      console.log(error);
    }
  },
  async saveTicket({ commit, state }, newTicket) {
    try {
      commit(
        'SET_SAVE_TICKET_RESULT',
        await ApiFunctionCalls.saveTicket(newTicket)
      );
    } catch (error) {
      console.log(error);
    }
  }
};

const mutations = {
  SET_TICKETS(state, data) {
    state.tickets = data;
  },
  SET_TICKETS_THREADS(state, data) {
    state.TicketThreads = data;
  },
  SET_TICKETS_TAB(state, data) {
    state.ticketsTab = data;
  },
  SET_TICKET_INFO(state, data) {
    state.ticketInfo = data;
  },
  SET_TICKETS_ELEMENTS_DATA(state, data) {
    state.ticketsElementsData = data;
  },
  SET_SAVE_TICKET_RESULT(state, data) {
    state.saveTicketResult = data;
  }
};

export default {
  namespaced: true,
  actions,
  state,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/tickets.js